<div class="callback-status">
  <span nz-icon nzType="loading" nzTheme="outline" class="text-primary callback-icon"></span>
  <p class="text-primary fs-18">Connecting to Shopify, please wait&hellip;</p>
</div>
